import { render, staticRenderFns } from "./libroRemuneraciones.vue?vue&type=template&id=d883f7bc&"
import script from "./libroRemuneraciones.vue?vue&type=script&lang=js&"
export * from "./libroRemuneraciones.vue?vue&type=script&lang=js&"
import style0 from "./libroRemuneraciones.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports